export default __webpack_public_path__ + "static/media/iconSmallScreen.9f9d899d.svg";